// Slugs das culturas GLOBAIS curadas (seed da migração 042, tabela `culturas`).
// Nenhum literal "banana"/"citros" solto no código — sempre estas constantes.
// Uma cultura CUSTOM (criada por uma org) nunca usa um destes slugs — ver
// validação de colisão em server/storage/index.ts (createCultura).
export const CULTURA_BANANA = "banana";
export const CULTURA_CITROS = "citros";

export const SLUGS_GLOBAIS = [CULTURA_BANANA, CULTURA_CITROS] as const;
export type SlugCulturaGlobal = (typeof SLUGS_GLOBAIS)[number];

/**
 * Culturas que o módulo **Cacho** atende (decisão D10 da arquitetura de Cultura).
 *
 * Cacho é de banana: mangará, fita, ciclo e cacho não existem em citros. A
 * cultura NUNCA é perguntada numa tela de trabalho — o gating apenas recorta a
 * lista que já existe, e é por isso que esta constante é uma lista e não um
 * `if (slug === "banana")` espalhado.
 */
export const CACHO_CULTURAS: readonly string[] = [CULTURA_BANANA];

/** O mínimo que `variedadeDoCacho` precisa saber. `cultura` ausente é aceito de propósito. */
export interface VariedadeComCultura {
  cultura?: { slug?: string | null } | null;
}

/**
 * A variedade pertence ao Cacho?
 *
 * 🔴 **Fail-open.** Variedade com `cultura` nula, indefinida ou sem slug CONTINUA
 * aparecendo. O que se esconde é só o que é COMPROVADAMENTE de outra lavoura —
 * a Pêra Rio no filtro de Controle de Fitas. Esconder o desconhecido faria uma
 * variedade sumir da tela por causa de um join que não veio, e uma variedade que
 * some é um cacho que ninguém consegue registrar.
 */
export function variedadeDoCacho(variedade: VariedadeComCultura): boolean {
  const slug = variedade?.cultura?.slug;
  if (!slug) return true;
  return CACHO_CULTURAS.indexOf(slug) !== -1;
}

/** Só as variedades do Cacho, preservando a ordem original. */
export function filtrarVariedadesDoCacho<V extends VariedadeComCultura>(variedades: V[]): V[] {
  return variedades.filter(variedadeDoCacho);
}
